import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { ColDef } from 'ag-grid-community';
import { AppState } from 'src/app/app.state';
import { FocusAreaConfigViewModel } from 'src/app/shared/models/autogenerated';
import { AdapCellClassRules } from 'src/app/shared/utils/ag-grid-utils';
import { nameof } from 'src/app/shared/utils/nameof';
import { selectFocusAreaConfigs } from '../../store/global-settings.selectors';
import { AgGridButtonRenderer } from 'src/app/shared/components/ag-grid-button-renderer/ag-grid-button-renderer.component';
import {
  AgGridButtonRendererActions,
  AgGridButtonRendererModel,
} from 'src/app/shared/models/ag-grid-button-renderer.model';
import { RiskAssessmentConfigTableActionsRendererComponent } from '../risk-assessment-config-table-actions-renderer/risk-assessment-config-table-actions-renderer.component';
import { RiskAssessmentConfigGridCellActions } from '../../models/risk-assessment-config-grid-cell-actions.model';

@Component({
  standalone: false,
  selector: 'app-risk-assessment-config-table',
  templateUrl: './risk-assessment-config-table.component.html',
  styleUrl: './risk-assessment-config-table.component.scss',
})
export class RiskAssessmentConfigsTableComponent {
  constructor(private store: Store<AppState>) {}

  focusAreasConfig$ = this.store.select(selectFocusAreaConfigs);

  @Output() editFocusAreaConfig = new EventEmitter<string>();
  @Output() deleteFocusAreaConfig = new EventEmitter<string>();

  configStoreTableName: string = 'RiskAssessmentConfigs';

  components = {};

  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    filterParams: {
      newRowsAction: 'keep',
    },
    resizable: true,
    cellClassRules: AdapCellClassRules,
  };

  columnDefs: ColDef[] = [
    {
      field: nameof<FocusAreaConfigViewModel>('title'),
      headerName: 'title',
      cellRenderer: AgGridButtonRenderer,
      cellRendererParams: {
        onInit: (
          actions: AgGridButtonRendererActions,
          data: FocusAreaConfigViewModel
        ) => {
          actions.setProps({
            text: data.title ?? '',
            style: 'blank',
            action: (data: FocusAreaConfigViewModel) => {
              this.editFocusAreaConfig.emit(data.id);
            },
          });
        },
      } as AgGridButtonRendererModel,
    },
    {
      field: nameof<FocusAreaConfigViewModel>('hideIfOnShore'),
      headerName: 'hidden in onshore',
    },
    {
      field: nameof<FocusAreaConfigViewModel>('hideIfOffShore'),
      headerName: 'hidden in offshore',
    },
    {
      maxWidth: 60,
      sortable: false,
      filter: false,
      resizable: false,
      cellRenderer: RiskAssessmentConfigTableActionsRendererComponent,
      cellRendererParams: {
        onDeleteClick: (focusAreaConfigId: string) =>
          this.deleteFocusAreaConfig.emit(focusAreaConfigId),
      } as RiskAssessmentConfigGridCellActions,
      pinned: 'right',
    },
  ];
}
